<script setup lang="ts">
const images = ['/images/group-1000002732.webp', '/images/group-1000002733.webp', '/images/group-1000002734.webp']

const responsiveOptions = ref([
  {
    breakpoint: '1199px',
    numVisible: 3,
    numScroll: 1,
  },
  {
    breakpoint: '767px',
    numVisible: 2,
    numScroll: 1,
  },
  {
    breakpoint: '575px',
    numVisible: 1,
    numScroll: 1,
  },
])

const page = ref(0)
</script>

<template>
  <div container w-full>
    <div row items-center>
      <h3 flex-grow text-24px font-bold>
        Top Ranked Ambassadors
      </h3>
      <button class="b-1 b-#ce0000 rounded-full bg-transparent p-[8px_16px] text-14px">
        Check Live Ranking
      </button>
    </div>

    <Carousel :page="page % 3" :value="images" :num-visible="3" :num-scroll="3" :responsive-options="responsiveOptions" mt-26.6px>
      <template #item="slotProps">
        <img w-full :src="slotProps.data" alt="">
      </template>
      <template #previousicon>
        <div />
      </template>
      <template #nexticon>
        <div />
      </template>

      <template #footer>
        <div mt-10px row>
          <button class="action" @click="page--">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
              <path fill-rule="evenodd" clip-rule="evenodd" d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22ZM4.29289 12.7071L10.6569 19.0711C11.0474 19.4616 11.6805 19.4616 12.0711 19.0711C12.4616 18.6805 12.4616 18.0474 12.0711 17.6569L7.41421 13H19C19.5523 13 20 12.5523 20 12C20 11.4477 19.5523 11 19 11H7.41421L12.0711 6.34315C12.4616 5.95262 12.4616 5.31946 12.0711 4.92893C11.6805 4.53841 11.0474 4.53841 10.6569 4.92893L4.29289 11.2929C3.90237 11.6834 3.90237 12.3166 4.29289 12.7071Z" fill="#D9D9D9" />
            </svg>
          </button>

          <button ml-16px class="action" @click="page++">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
              <path fill-rule="evenodd" clip-rule="evenodd" d="M12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22ZM19.7071 12.7071L13.3431 19.0711C12.9526 19.4616 12.3195 19.4616 11.9289 19.0711C11.5384 18.6805 11.5384 18.0474 11.9289 17.6569L16.5858 13H5C4.44772 13 4 12.5523 4 12C4 11.4477 4.44772 11 5 11H16.5858L11.9289 6.34315C11.5384 5.95262 11.5384 5.31946 11.9289 4.92893C12.3195 4.53841 12.9526 4.53841 13.3431 4.92893L19.7071 11.2929C20.0976 11.6834 20.0976 12.3166 19.7071 12.7071Z" fill="#D9D9D9" />
            </svg>
          </button>
        </div>
      </template>
    </Carousel>
  </div>
</template>

<style scoped lang="scss">
:deep(.p-carousel) {
  .p-carousel-next,
  .p-carousel-prev {
    display: none;
  }
}
:deep(.p-carousel-indicators) {
  display: none;
}
:deep(.p-carousel-item) {
  padding-left: 0.5rem;
  padding-right: 0.5rem;
}
:deep(.p-carousel-items-container) {
  @apply m-x--0.5rem;
}
.action {
  display: flex;
  padding: 10px 16px;
  justify-content: center;
  align-items: center;
  gap: 10px;
  align-self: stretch;
  border-radius: 32px;
  border: 1px solid #fff;
  background: rgba(104, 92, 240, 0.1);
}
</style>
